// tslint:disable: max-line-length
import { AssistentItem } from './assistent_config';
import { compareObjects } from '../../datenauswertung/generisch/helper';
import { ContextService } from '../../../services/context_service';
import { createStructureForKennziffern, prepareStructureForKennziffern } from '../functions/createStructureForKennziffern';
import { DataService } from '../../../services/data_service';
import { DateneingabeCO2KomplexForm } from '../DateneingabeCO2KomplexForm';
import { DateneingabeEnergiedatenKomplexForm } from '../DateneingabeEnergiedatenKomplexForm';
import { AuswahlErfassungsmodus } from '../functions/AuswahlErfassungsmodus';
import { getCustomDataPreset } from '../custom/getCustomDataPreset';
import { getCustomFormConfig } from '../co2_custom/getCustomFormConfig';
import { getErrorLevelKey } from '../../../core/forms/helpers/errorLevelTools';
import { getExtraFormElement } from '../custom/getExtraFormElement';
import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
// import * as Moment from 'moment';
import * as React from 'react';
import { renderDatensatzForSelect } from './RenderDatenForSelect';
import { saveDataKennziffern, transformWerteKennziffern } from '../functions/dataHandlingForKennziffern';
import { StructureTool } from '../../../core/forms/helpers/structure_tool';
import style from './Assistent.less';
import styleWForm from '../../../core/forms/style/WForm.less';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WActionButton } from '../../../core/elements/WActionButton';
import { WFormConfig } from '../../../core/forms/WFormFramework';
import { WSpinner } from '../../../core/elements/spinner/WSpinner';
import { getAutoSaveIntervall } from './assistent_helpers';
import { setB5Vorjahresdaten } from '../custom/setB5Vorjahresdaten';
import { WHelpIcon } from '../../../core/elements/WHelpIcon';

interface AssistentEntityFormProps extends React.ClassAttributes<any> {
    item: AssistentItem;
    data: any;
    jahr: number;
    standort: any;
    isPruefung?: boolean; // Für direkte Prüfung
    dataItem?: any;
    pruefItem?: any; // Nur zur Validierung
    extraFormElementBefore?: any;
    extraFormElementAfter?: any;
    notifySave?: (t: number) => void;
    onValidationStateChange?: (state: any) => void;
    onPruefItemChange?: (datensatz: any, state: any) => void;
    reCheck?: (anzahl: number) => void;
    onChangeUpdateKey?: (key: string) => void;
    scrollTop?: () => void;
    onFormReady?(): void;
    onFormSaving?: (status: boolean) => void;
    callBeforeDelete?: (data: any, callback: () => void) => void;
}

interface AssistentEntityFormState {
    item: AssistentItem;
    selectedDatensatz: any;
    bundle: any;
    tidAnnounced: number;
    formConig: any;
    presetFormConfig: any;
    blockMessage: string | JSX.Element;
    keyAddOn: number;
    showSpinner: boolean;
}

export class AssistentEntityForm extends React.Component<AssistentEntityFormProps, AssistentEntityFormState> {

    constructor(props: any) {
        super(props);
        let selectedDatensatz = undefined;
        if (!props.item.singleItem) { // Nicht bei Single-Datensätzen
            // Die Datensatzliste holen
            const daten = this.props.data[this.props.item.entity] || [];
            let list = [];
            if (props.item.entity === IDs.ENT_STANDORT) {
                list = [...daten];
            } else {
                list = daten.filter((r: any) =>
                    (!r.monat || r.monat === 0) && (!r.jahr || r.jahr === this.props.jahr)
                    && (!r.standort_tid_orig || r.standort_tid_orig === (this.props.standort || {}).tid)
                    && ((this.parentEntities || []).indexOf((this.props.item || {}).entity) === -1 || (+r.parent_tid || 0) === 0)
                );
            }

            // DIE GEMERKTE TID HOLEN
            if (!this.props.isPruefung) {
                const contextKey = AssistentEntityForm.getContextKey(this.props.item, this.props.jahr, (this.props.standort || {}).tid);
                const tidFromContext = this.contextService.get(contextKey);
                // DATENSATZ HOLEN
                if (tidFromContext !== undefined) {
                    selectedDatensatz = list.find((s: any) => +s.tid === +tidFromContext);
                }
                if (!selectedDatensatz && list.length > 0) {
                    selectedDatensatz = this.findFirstSelection(list);
                }
            }
        }
        this.state = {
            item: props.item,
            selectedDatensatz: props.item.singleItem ? this.getSingleItem(props) : selectedDatensatz,
            bundle: undefined,
            tidAnnounced: undefined,
            formConig: undefined,
            presetFormConfig: {},
            blockMessage: undefined,
            keyAddOn: 0,
            showSpinner: false
        };
        this.onChange = this.onChange.bind(this);
        this.loadBundle = this.loadBundle.bind(this);
        this.updateArchiv = this.updateArchiv.bind(this);
        this.updateLocalData = this.updateLocalData.bind(this);
    }

    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    private saveHandle: number;
    private firstRender = true;
    private hasNewDataRow = false;
    private pruefItemAnzahl: number;
    private lastKennKey: string;
    private lastEigenstromKey: string;
    private onChangeCnt = 0;
    private lastCopy: any = undefined;
    private unmounted = false;
    private currentFormTarget: any;
    private parentEntities: Array<string> = [
        IDs.ENT_CO2_SCOPE3_PENDELN, IDs.ENT_CO2_SCOPE3_REISEN, IDs.ENT_CO2_SCOPE3_TRANSPORT_NACHGELAGERT,
        IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT
    ];
    private tempCustomFormConfig: any = {};
    private lastItem: any = null;
    private formIsValid: boolean;
    private isSaveHandleRunning: boolean = false;
    private lastFormKey: string;

    componentDidMount() {
        if (this.props.notifySave) {
            this.props.notifySave(undefined);
        }
        if (this.props.item.entity === IDs.ENT_KENNZIFFERN_GENERATED) {
            this.initKennziffern();
        } else {
            this.loadFormConfig();
        }
        this.loadBundle();
        this.setUnternehmensdatenInHauptsitz();
    }

    componentWillUnmount() {
        this.unmounted = true;
        const { item } = this.props;
        if (this.hasNewDataRow) {
            // Gibt es neuen Datensatz, feuert Reload.
            let entity = item.entity;
            if (entity === IDs.ENT_KENNZIFFERN_GENERATED) {
                entity = IDs.ENT_KENNZAHLEN_WERTE;
            }
            // console.log('componentWillUnmount -> Reload', entity);
            this.triggerService.fire('reload', entity);
            this.initKennziffern = this.initKennziffern.bind(this);
        }
    }

    findFirstSelection(list: Array<any>): any {
        let found: any = undefined;
        const entity = this.props.item.entity;
        if (this.props.item.customFilter) {
            list = list.filter((row: any) => this.props.item.customFilter(row));
        }
        list.forEach((item: any) => {
            if (entity === IDs.ENT_STANDORT) {
                if (item.tid === (this.props.standort || {}).tid) {
                    found = item;
                }
            } else if (!found) {
                found = item;
            } else {
                if (item.abrechnungszeitraum_bis > found.abrechnungszeitraum_bis) {
                    found = item;
                }
            }
        });
        return found;
    }

    getSingleItem(props: any) {
        let daten = props.data[props.item.entity] || [];
        if (props.item.entity === IDs.ENT_KENNZIFFERN_GENERATED) {
            const werte = this.props.data[IDs.ENT_KENNZAHLEN_WERTE];
            daten = transformWerteKennziffern(werte);
        }
        const datenFiltered = daten.filter((ds: any) =>
            (!ds.monat || ds.monat === 0) && (!ds.jahr || ds.jahr === this.props.jahr)
            && (!ds.standort_tid_orig || ds.standort_tid_orig === (this.props.standort || {}).tid)
            && ((this.parentEntities || []).indexOf((props.item || {}).entity) === -1 || (+ds.parent_tid || 0) === 0)
        );
        // const datenFiltered = daten.filter((ds: any) =>
        //     (!ds.jahr || ds.jahr === this.props.jahr) && (!ds.standort_tid_orig || ds.standort_tid_orig === (this.props.standort || {}).tid));
        if (datenFiltered && datenFiltered.length > 0) {
            return datenFiltered[0];
        }
        return undefined;
    }

    setUnternehmensdatenInHauptsitz() {
        const { data } = this.props;
        if (Array.isArray(data[IDs.ENT_UNTERNEHMENSDATEN]) && data[IDs.ENT_UNTERNEHMENSDATEN].length > 0 &&
            Array.isArray(data[IDs.ENT_STANDORT]) && data[IDs.ENT_STANDORT].length > 0) {
            const unt = data[IDs.ENT_UNTERNEHMENSDATEN][0];
            const hauptList = data[IDs.ENT_STANDORT]
                .filter((s: any) => s.standort_typ_tid_orig === 1 && (s.strasse !== unt.strasse || s.hausnummer !== unt.hausnummer || s.ort !== unt.ort || s.plz !== unt.plz || s.ort_gtz !== unt.ort_gtz))
                .map((s: any) => {
                    return {
                        tid: s.tid,
                        strasse: unt.strasse,
                        hausnummer: unt.hausnummer,
                        ort: unt.ort,
                        plz: unt.plz,
                        ort_gtz: unt.ort_gtz
                    };
                });
            // console.log(hauptList);
            if (hauptList.length > 0) {
                hauptList.forEach((h: any) => {
                    const idx = data[IDs.ENT_STANDORT].findIndex((s: any) => s.tid === h.tid);
                    if (idx >= 0) {
                        const dataOrig = data[IDs.ENT_STANDORT][idx];
                        data[IDs.ENT_STANDORT][idx] = { ...dataOrig, ...h };
                    }
                });
                this.dataService.saveDataList(IDs.ENT_STANDORT, hauptList, () => {
                    this.triggerService.fire('reload', IDs.ENT_STANDORT);
                }, IDs.MOD_ETOOL);
            }
        }
    }

    setHauptsitzdatenInUnternehmen(hauptsitz: any): void {
        const { data } = this.props;
        if (Array.isArray(data[IDs.ENT_UNTERNEHMENSDATEN]) && data[IDs.ENT_UNTERNEHMENSDATEN].length > 0) {
            const unt = data[IDs.ENT_UNTERNEHMENSDATEN][0];
            if (unt) {
                const newVals: any = { tid: unt.tid };
                let changeCnt = 0;
                ['strasse', 'hausnummer', 'ort', 'plz', 'ort_gtz'].forEach((k: string) => {
                    if (hauptsitz[k] && unt[k] !== hauptsitz[k]) {
                        unt[k] = hauptsitz[k];
                        newVals[k] = hauptsitz[k];
                        changeCnt++;
                    }
                });
                if (changeCnt > 0) {
                    this.setState({ showSpinner: true }, () =>
                        this.dataService.setData(IDs.MOD_ETOOL, IDs.ENT_UNTERNEHMENSDATEN, newVals, () => this.setState({ showSpinner: false }))
                    );
                }
            }
        }
    }

    loadFormConfig() {
        const struct_tool = new StructureTool(IDs.MOD_ETOOL, this.props.data);
        struct_tool.generateFormConfig(this.props.item.entity, (formConig: WFormConfig) => this.setState({ formConig }));
    }

    initKennziffern() {
        const { kenn_dyn, kenn_def } = prepareStructureForKennziffern(this.props.data);
        const struct = createStructureForKennziffern(kenn_def, kenn_dyn, IDs.ENT_KENNZIFFERN_GENERATED);
        const struct_tool = new StructureTool(IDs.MOD_ETOOL, this.props.data);
        const keyAddOn = this.state.keyAddOn + 1;
        struct_tool.generateFormConfigFromStructure(IDs.ENT_KENNZIFFERN_GENERATED,
            { [IDs.ENT_KENNZIFFERN_GENERATED]: struct }, (formConfig: WFormConfig) => {
                this.setState({ keyAddOn, presetFormConfig: { [IDs.ENT_KENNZIFFERN_GENERATED]: formConfig } }, () => { });
            });
    }

    loadBundle() {
        const entity = this.props.item.entity;
        this.dataService.loadBundleForModul(entity, IDs.MOD_ETOOL, (result: any) => {
            // console.log('loadBundleForModul', entity, result);
            const bundle = result.bundle;
            if (this.state.item.bundleFilterFunc) {
                this.state.item.bundleFilterFunc(bundle, this.props.data);
            }
            if (result) {
                this.setState({
                    bundle: {
                        ...result.bundle,
                        ...(entity === IDs.ENT_KLIMAGASE ? { art_tid: this.props.data[IDs.ENT_KLIMAGASE_ART] } : {})
                    }
                });
            } else {
                this.setState({ bundle: {} });
            }
        });
    }

    checkAllowContinue(showItem: any) {
        if (this.props.item.customAllowContinue) {
            this.props.item.blockContinue = !this.props.item.customAllowContinue(showItem);
            const blockMessage = this.props.item.blockContinue ? this.props.item.blockMessage : undefined;
            if (this.state.blockMessage !== blockMessage) {
                this.setState({ blockMessage });
            }
        }
    }

    render(): JSX.Element {
        const { reCheck } = this.props;
        const { item } = this.state;
        if (this.props.scrollTop && (this.lastItem == null || this.lastItem.gliederung !== item.gliederung)) {
            this.props.scrollTop();
            this.lastItem = item;
        }

        if (item.entity === IDs.ENT_KENNZIFFERN_GENERATED && !this.state.presetFormConfig[item.entity]) {
            return <div style={{ padding: 20 }}>Lade ...</div>;
        }
        // Änderungen an der Kennziffern-Konfiguration prüfen
        if (this.props.item.entity === IDs.ENT_KENNZIFFERN_GENERATED) {
            const kenn_dyn = this.props.data[IDs.ENT_KENNZAHLEN_DYNAMISCH];
            let key_str = '';
            kenn_dyn.forEach((kenn: any) => {
                key_str += kenn.kuerzel + '_' + kenn.name + '_';
            });
            // console.log('FORMKEY OLD:' , this.lastKennKey);
            // console.log('FORMKEY NEW:' , key_str);
            if (this.lastKennKey !== undefined && this.lastKennKey !== key_str) {
                this.lastKennKey = key_str;
                // console.log('FORMKEY TRIGGER!');
                this.initKennziffern();
            } else {
                this.lastKennKey = key_str;
            }
        }
        if (this.props.item.entity === IDs.ENT_ANLAGEN_EIGENSTROM || this.props.item.entity === IDs.ENT_ENERGIEDATEN_EIGENSTROM) {
            const eigenstrom_values = this.props.data[IDs.ENT_ANLAGEN_EIGENSTROM];
            const eigenstrom_typen = this.props.data[IDs.ENT_ANLAGEN_EIGENSTROM_TYPEN];
            const eigenstrom_typen_filtered = eigenstrom_typen.filter((es: any) => eigenstrom_values.some((aw: any) =>
                es.typ === 'S' && aw.anlagen_eigenstrom_typ_tid_orig === es.tid && aw.standort_tid_orig === (this.props.standort || {}).tid
            ));

            let eigenstrom_key = '';
            eigenstrom_typen_filtered.forEach((es: any) => eigenstrom_key += es.name);
            if (this.lastEigenstromKey !== undefined && this.lastEigenstromKey !== eigenstrom_key) {
                this.lastEigenstromKey = eigenstrom_key;
                const keyAddOn = this.state.keyAddOn + 1;
                this.setState({ keyAddOn });
            } else {
                this.lastEigenstromKey = eigenstrom_key;
            }
        }

        const daten = this.props.data[item.entity] || [];
        // console.log('Daten', daten);
        const datenFiltered = daten.filter((ds: any) => (item.entity === IDs.ENT_STANDORT || (
            (!ds.monat || ds.monat === 0) && (!ds.jahr || ds.jahr === this.props.jahr)
            && (!ds.standort_tid_orig || ds.standort_tid_orig === (this.props.standort || {}).tid)
            && ((this.parentEntities || []).indexOf(item.entity) === -1 || (+ds.parent_tid || 0) === 0)
        )) && (!item.customFilter || item.customFilter(ds))
        );
        // console.log('datenFiltered', datenFiltered);

        const datenAnzahl = datenFiltered.length;
        if (reCheck && this.pruefItemAnzahl !== datenAnzahl && item.entity !== IDs.ENT_KENNZIFFERN_GENERATED) {
            this.pruefItemAnzahl = datenAnzahl;
            reCheck(datenAnzahl);
        }

        // console.log('DS', this.props.standort, datenFiltered, this.state.bundle);
        if (!this.state.bundle) {
            return <div style={{ padding: 20 }}>Lade ...</div>;
        }
        /* if(this.props.dataItem) {
            console.log('AssistentEntityForm - direct item', this.props.dataItem)
        } */
        let showItem = this.props.dataItem || this.state.selectedDatensatz;
        const customFormConfig = getCustomFormConfig(
            item.entity, showItem, this.props.data, item.group,
            { jahr: this.props.jahr, standort_tid: (this.props.standort || {}).tid }
        );
        // WKETOOL-198: 5. Scope 3 - Feld "Einheit"
        // Beim Warten auf dem kommenden Speichern soll der FormKey nicht geändert werden, damit der User weiter eingeben kann.
        const reactKey = this.isSaveHandleRunning && this.lastFormKey ? this.lastFormKey : this.getFormKey(item, showItem, customFormConfig);
        this.lastFormKey = reactKey;

        if (this.firstRender) {
            this.firstRender = false;
            this.checkAllowContinue(showItem);
        }
        // console.log('Render Assstent: ', item.entity, this.props.data[item.entity]);
        const additionalFormConfig: any = {};
        const konfiguration: Array<any> = this.props.data[IDs.ENT_KONFIGURATION] || [];
        const alternatives_system: boolean = konfiguration
            .some((param: any) => param.alternatives_system_orig === 1);
        if (!alternatives_system) {
            additionalFormConfig.messsystem = { hidden: true };
            additionalFormConfig.kalibrierung = { hidden: true };
        }
        // Vorbelegung der neuen Daten
        if (!showItem) {
            const dataPreset: any = getCustomDataPreset(item.entity, showItem, this.props.data, { jahr: this.props.jahr }) || {};
            showItem = {};
            this.setDataPreset(item.entity, showItem);
            showItem = { ...showItem, ...dataPreset };
        }
        const { extraFormElementAfter, extraFormElementBefore } = getExtraFormElement(
            item.entity, showItem, this.props.data, null, null, this.contextService,
            { jahr: this.props.jahr, standort_tid: (this.props.standort || {}).tid }
        ) || {};
        const WFormId: string = `${(item || {}).entity}_${this.props.jahr}_${+showItem.tid || 0}`

        return (
            <div
                className={style.entityForm}
                style={{ marginTop: 0, borderRadius: '0 0 10px 10px', paddingBottom: 10 }}
                onClick={(event: any) => this.currentFormTarget = event.target}
                onChange={(event: any) => this.currentFormTarget = event.target}
            >
                {!this.props.isPruefung && !this.props.item.singleItem && this.renderDatensatzSelect(datenFiltered, showItem)}
                {!this.props.isPruefung && this.props.item.singleItem && this.props.item.customTopElement &&
                    this.props.item.entity !== IDs.ENT_KENNZIFFERN_GENERATED &&
                    this.props.item.entity !== IDs.ENT_STANDORT &&
                    this.props.item.entity !== IDs.ENT_UNTERNEHMENSDATEN &&
                    this.renderCutomTopElement(showItem)
                }
                {!this.props.isPruefung && this.state.blockMessage &&
                    <div style={{ marginRight: 7, padding: 3, boxSizing: 'border-box' }}>
                        {this.state.blockMessage}
                    </div>
                }
                {(item.entity || '').startsWith('co2_scope3_') &&
                    <DateneingabeCO2KomplexForm
                        WFormId={WFormId}
                        key={reactKey}
                        module={item.module}
                        data={this.props.data}
                        dataItem={showItem}
                        jahr={this.props.jahr}
                        additionalFormItems={item.additionalFormItems}
                        // extraFormElementAfter={item.extraFormElementAfter}
                        entity={{ entity: item.entity, bundle: this.state.bundle }}
                        standort={this.props.standort}
                        presetFormConfig={item.entity === IDs.ENT_KENNZIFFERN_GENERATED && this.state.presetFormConfig[item.entity]}
                        isFirst={true}
                        layout='flowV2'
                        customCssStyle={item.customCssStyle}
                        selectOptionAsRadio={item.selectOptionAsRadio}
                        disableFieldSelectDefaultOptions={item.disableFieldSelectDefaultOptions}
                        announceTid={(tidAnnounced: number, wasDeleted: boolean) => {
                            if (wasDeleted) {
                                this.setState({ tidAnnounced: undefined, selectedDatensatz: undefined }, () => {
                                    // console.log('Announce deleted: ', tidAnnounced);
                                    this.props.onPruefItemChange({ tid: tidAnnounced }, 'deleted');
                                });
                            } else {
                                this.setState({ tidAnnounced });
                            }
                        }}
                        onValidationStateChange={(state: any) => {
                            // console.log('New Validation: ', this.props.item.entity, state);
                            if (state) {
                                this.formIsValid = Object.keys(state).length === 0;
                                if (this.props.onValidationStateChange) {
                                    this.props.onValidationStateChange(state); // State hochreichen (nur für AssistentPruefer)
                                }
                                if (this.props.onPruefItemChange) {
                                    this.props.onPruefItemChange(showItem, state);
                                }
                            }
                        }}
                        onChange={this.onChange}
                        forceOnChange={true}
                        customFormConfig={{ ...item.customFormConfig, ...additionalFormConfig, ...customFormConfig }}
                        bundleFilterFunc={item.bundleFilterFunc}
                        reloadBundle={this.loadBundle}
                        /*formSimpleValidationMsg={['*']}*/
                        externalDescriptionElement={item.externalDescriptionElement}
                        externalTopElement={this.props.item.customTopElement && this.renderCutomTopElement(showItem)}
                        onFormChangeInteractive={item.onFormChangeInteractive}
                        getExtraElement={item.getExtraElement}
                        isInAssisten={true}
                        isPruefung={this.props.isPruefung}
                        renderBtnDetailierteErfassung={(onWillChange?: () => void) =>
                            // <DetaillierteErfassungScope3
                            //     data={this.props.data}
                            //     onWillChange={onChecked}
                            // />
                            <AuswahlErfassungsmodus
                                data={this.props.data}
                                onWillChange={onWillChange}
                            />
                        }
                        formGroupOrder={item.formGroupOrder}
                    />
                }
                {!(item.entity || '').startsWith('co2_scope3_') &&
                    <DateneingabeEnergiedatenKomplexForm
                        WFormId={WFormId}
                        key={reactKey}
                        module={item.module}
                        data={this.props.data}
                        dataItem={showItem}
                        jahr={this.props.jahr}
                        additionalFormItems={item.additionalFormItems}
                        extraFormElementBefore={{ ...(item.extraFormElementBefore || {}), ...(extraFormElementBefore || {}) }}
                        extraFormElementAfter={{ ...(item.extraFormElementAfter || {}), ...(extraFormElementAfter || {}) }}
                        entity={{ entity: item.entity, bundle: this.state.bundle }}
                        standort={this.props.standort}
                        presetFormConfig={item.entity === IDs.ENT_KENNZIFFERN_GENERATED && this.state.presetFormConfig[item.entity]}
                        isFirst={true}
                        layout='flowV2'
                        customCssStyle={item.customCssStyle}
                        selectOptionAsRadio={item.selectOptionAsRadio}
                        disableFieldSelectDefaultOptions={item.disableFieldSelectDefaultOptions}
                        announceTid={(tidAnnounced: number, wasDeleted: boolean) => {
                            if (wasDeleted) {
                                this.setState({ tidAnnounced: undefined, selectedDatensatz: undefined }, () => {
                                    // console.log('Announce deleted: ', tidAnnounced);
                                    this.props.onPruefItemChange({ tid: tidAnnounced }, 'deleted');
                                });
                            } else {
                                this.setState({ tidAnnounced });
                            }
                        }}
                        onValidationStateChange={(state: any) => {
                            // console.log('New Validation: ', this.props.item.entity, state);
                            if (state) {
                                if (item.entity === IDs.ENT_STANDORT && !showItem.tid) {
                                    // WKETOOL-69: 352 getCustomFormConfig
                                    // "PLZ" und "Energiedaten erfassen" werden beim neuen DS nicht als Pflichtfelder definiert.
                                    delete (state.energiedaten_erfassen);
                                    delete (state.plz);
                                }
                                this.formIsValid = Object.keys(state).length === 0;

                                if (this.props.onValidationStateChange) {
                                    this.props.onValidationStateChange(state);  // State hochreichen (nur für AssistentPruefer)
                                }
                                if (this.props.onPruefItemChange) {
                                    this.props.onPruefItemChange(showItem, state);
                                }
                            }
                        }}
                        onChange={this.onChange}
                        customOnSaveDone={item.customOnSaveDone}
                        forceOnChange={true}
                        customFormConfig={{ ...item.customFormConfig, ...additionalFormConfig, ...customFormConfig }}
                        bundleFilterFunc={item.bundleFilterFunc}
                        reloadBundle={this.loadBundle}
                        /*formSimpleValidationMsg={['*']}*/
                        externalDescriptionElement={item.externalDescriptionElement}
                        externalTopElement={this.props.item.customTopElement && this.renderCutomTopElement(showItem)}
                        onFormChangeInteractive={item.onFormChangeInteractive}
                        getExtraElement={item.getExtraElement}
                        isInAssisten={true}
                        isPruefung={this.props.isPruefung}
                        onFormReady={this.props.onFormReady}
                        formGroupOrder={item.formGroupOrder}
                    />
                }
                {!this.props.isPruefung && !this.props.item.singleItem && this.state.selectedDatensatz && !this.props.dataItem ?
                    <div
                        className={style.entityForm}
                        style={{ marginTop: -40, padding: '0px 33px 10px 25px', boxShadow: 'none' }}
                    >
                        <div>
                            Sie haben die Möglichkeit einen zusätzlichen Datensatz der Eingabe hinzuzufügen. Klicken Sie dazu einfach auf "+ Zusätzlichen Datensatz erfassen". Alternativ können Sie den oben eingegebenen Datensatz auch wieder löschen.
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: 10 }}>
                            {this.renderButtonAdd()}
                            {this.renderButtonDel()}
                        </div>
                    </div>
                    : null
                }
                {this.state.showSpinner && <WSpinner label='' />}
            </div>
        );
    }

    setDataPreset(entity: string, data: any) {
        switch (entity) {
            case IDs.ENT_ENERGIEDATEN_STROM:
                data.abrechnungsmodus_orig = 1;
                data.abrechnungsart_orig = 1;
                break;
            case IDs.ENT_ENERGIEDATEN_WAERME:
                data.abrechnungsmodus_orig = 1;
                data.abrechnungsart_orig = 1;
                break;
            case IDs.ENT_ENERGIEDATEN_WASSER:
                data.abrechnungsmodus_orig = 1;
                data.abrechnungsart_orig = 1;
                break;
            case IDs.ENT_CO2_SCOPE3_PENDELN:
            // no break
            case IDs.ENT_CO2_SCOPE3_TRANSPORT_NACHGELAGERT:
            // no break
            case IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT:
                data.teilstrecken_orig = 2;
                break;
            case IDs.ENT_CO2_SCOPE3_REISEN:
                data.firmenfahrzeug_orig = 2;
                data.teilstrecken_orig = 2;
                break;
        }
    }

    onChange(entityName: string, data: any, onSaveDone?: () => void, timeout?: number, field?: any) {
        // console.log('onChange', entityName, this.props.isPruefung, this.onChangeCnt);
        if (this.props.isPruefung) {
            return;
        }
        const prevDataItem = { ...(this.lastCopy || {}) };
        if ((data || {}).tid > 0 && (this.lastCopy || {}).tid > 0) {
            if (compareObjects(data, this.lastCopy)) {
                // console.log('onChange: Nothing changed!' /*, this.lastCopy, data*/);
                return;
            } else {
                // console.log('onChange: Actual change found!' /*, this.lastCopy, data*/);
            }
        }
        this.lastCopy = { ...data };

        // Ein Update der lokalen Daten geht vor der Ankunft der Daten aus dem Server.
        const doNotLocalUpdate = [IDs.ENT_VSME_B1, IDs.ENT_VSME_B3];
        if (doNotLocalUpdate.indexOf(entityName) === -1) {
            this.updateLocalData(entityName, data);
        }

        this.onChangeCnt++;
        if (this.props.item.customOnChange) {
            this.props.item.customOnChange(data, this.props.data, this.contextService, prevDataItem);
        }
        this.checkAllowContinue(data);

        let callAfterReload: () => void;

        // Änderung der Adress-Felder vom Unternehmen auf den Hauptsitz übernehmen
        if (entityName === IDs.ENT_UNTERNEHMENSDATEN) {
            this.setUnternehmensdatenInHauptsitz();
            if (this.props.item.updateAssistentItem) {
                const itemNew = this.props.item.updateAssistentItem(data);
                if (itemNew) {
                    callAfterReload = () => this.setState({ item: itemNew, keyAddOn: this.state.keyAddOn + 1 });
                    timeout = 0;
                }
            }
        }

        // Änderung der Adress-Felder vom Hauptsitz aufs Unternehmen übernehmen
        if (entityName === IDs.ENT_STANDORT) {
            if (data.standort_typ_tid === 1 || data.standort_typ_tid_orig === 1) {
                this.setHauptsitzdatenInUnternehmen(data);
                // Ungültige Eingabe im Standort muss gesperrt werden. Ausnahme bei der Veranstaltung (WKETOOL-76).
                if (!this.formIsValid) {
                    return;
                }
            }
        }

        // Übernahme der Vorjahresdaten
        if (entityName === IDs.ENT_VSME_B5) {
            setB5Vorjahresdaten(data, field, this.props.data);
        }

        // Automatische Speicherung. Wir speichern nach einer kurzen Pause
        const autoSaveIntervall = getAutoSaveIntervall(this.props.data[IDs.ENT_KONFIGURATION]);
        let waitTime = (typeof timeout === 'number' && timeout >= 0) ? timeout : autoSaveIntervall;

        // Änderungen an Auswahl und Datum-Feldern
        if (field && field.typ && ['select', 'datepicker'].indexOf(field.typ) !== -1) {
            // speichern wir sofort.
            waitTime = 0;
        }

        const saveForms = (callback?: () => void) => {
            console.log('*** Automatische Speicherung beginnt ... ***', entityName);
            if (entityName === IDs.ENT_KENNZIFFERN_GENERATED) {
                const hasValidValue = saveDataKennziffern(data, this.props.data, this.dataService, this.triggerService,
                    () => {
                        if (this.props.notifySave) {
                            this.props.notifySave(new Date().getTime());
                        }
                        if (callback) {
                            callback();
                        }
                    });
                this.props.reCheck(hasValidValue ? 1 : 0);
            } else {
                if (entityName === IDs.ENT_STANDORT) {
                    const standorte = this.props.data[IDs.ENT_STANDORT] || [];
                    const hasHauptsitz: boolean = standorte.length
                        ? standorte.some((item: any) => item.standort_typ_tid === 'Hauptsitz' && item.tid !== data.tid)
                        : false;
                    const isHauptsitz: boolean = (data.standort_typ_tid || null) === 1;
                    if (hasHauptsitz && isHauptsitz) {
                        alert('Änderung kann nicht gespeichert werden!');
                        if (callback) {
                            callback();
                        }
                        return;
                    }
                }
                this.dataService.saveData(entityName, data, undefined, false,
                    (suc: boolean, saveTid: number) => {
                        if (this.props.notifySave) {
                            this.props.notifySave(new Date().getTime());
                        }
                        if (suc) {
                            if (data.tid === 0 && saveTid > 0) {
                                data.tid = saveTid;
                            }
                            // this.triggerService.fire('reload', entityName);
                            // triggerService.fire('reload') ladet alle Datensätze. Wir brauchen hier nur diesen Datensatz aktualisieren,
                            // dadurch schieben wir triggerService.fire('reload’) in componentWillUnmount.
                            this.reloadDataRow(entityName, data.tid, callAfterReload);
                        }
                        this.setFocusOnInput();
                        if (typeof onSaveDone === 'function') {
                            onSaveDone();
                        }
                        if (callback) {
                            callback();
                        }
                    },
                    IDs.MOD_ETOOL);
            }
        };

        const saveForms2 = () => {
            // Can't perform a React state update on an unmounted component ...
            if (this.unmounted) {
                saveForms(() => {
                    if (typeof this.props.onFormSaving === 'function') {
                        this.props.onFormSaving(false);
                    }
                });
            } else {
                this.setState({ showSpinner: true }, () => {
                    saveForms(() => {
                        this.setState({ showSpinner: false });
                        if (typeof this.props.onFormSaving === 'function') {
                            this.props.onFormSaving(false);
                        }
                    });
                });
            }
        }

        this.hasNewDataRow = true;
        const saveHandle = window.setTimeout(() => {
            this.isSaveHandleRunning = false;
            const { item } = this.state;
            if (typeof item.callBeforeOnFormAutoSave === 'function') {
                item.callBeforeOnFormAutoSave(data, saveForms2);
            } else {
                saveForms2();
            }
        }, waitTime);

        this.props.notifySave(undefined);
        clearTimeout(this.saveHandle);
        this.saveHandle = saveHandle;
        this.isSaveHandleRunning = true;

        if (typeof this.props.onFormSaving === 'function') {
            this.props.onFormSaving(true);
        }
    }

    // diffCustomFormConfig(entityName: string, data: any) {
    //     const formKey = data._formKey;
    //     const cfOld = this.tempCustomFormConfig[formKey];
    //     const cfNew = getCustomFormConfig(entityName, data, this.props.data);
    //     // console.log(entityName, data, cfOld, cfNew);
    //     if (JSON.stringify(cfOld) !== JSON.stringify(cfNew)) {
    //         this.tempCustomFormConfig[formKey] = cfNew;
    //         return true;
    //     }
    //     return false;
    // }

    updateLocalData(entityName: string, data: any) {
        // Update der lokalen Daten
        const update: any = { [entityName]: data };
        this.triggerService.fire('updateLocalDataByEntity', 'dataObject', update);
        // Update der Items wie Berechnung-Knöpfe
        if (this.props.onChangeUpdateKey) {
            const key = entityName + '_' + data.energietraeger_tid + '_' + data.einheit_tid_orig;
            this.props.onChangeUpdateKey(key);
        }
    }

    reloadDataRow(entity: string, tid: number, callback: () => void) {
        const { data } = this.props;
        // console.log('reloadDataRow', entity, tid);
        this.dataService.loadData(entity, { tid }, { resolve: true }, (res: any) => {
            // console.log('reloadDone', entity, tid, res);
            if (Array.isArray(res[entity]) && res[entity].length > 0 && Array.isArray(data[entity])) {
                const row = res[entity][0];
                if (this.unmounted) { // Direkt setzen
                    const idx = data[entity].findIndex((r: any) => r.tid === row.tid);
                    if (idx >= 0) {
                        const rowOld = data[entity][idx];
                        data[entity][idx] = row;
                        // console.log('reloadSet',  entity, tid);
                        if (data.callback) {
                            data.callback(data);
                        }
                        this.updateArchiv(rowOld, row);
                    } else {
                        data[entity].push(row);
                    }
                } else {
                    this.setState({ selectedDatensatz: row }, () => {
                        const idx = data[entity].findIndex((r: any) => r.tid === row.tid);
                        if (idx >= 0) {
                            const rowOld = data[entity][idx];
                            data[entity][idx] = row;
                            // console.log('reloadSet',  entity, tid, data.callback);
                            if (data.callback) {
                                data.callback(data);
                            }
                            this.updateArchiv(rowOld, row);
                        } else {
                            data[entity].push(row);
                        }
                    });
                }
            }
            if (typeof callback === 'function') {
                callback();
            }
        }, IDs.MOD_ETOOL);

        if ((this.parentEntities || []).indexOf(entity) !== -1) {
            const keyAddOn = this.state.keyAddOn + 1;
            this.setState({ keyAddOn });
            this.dataService.loadData(entity, { parent_tid: tid }, { resolve: true }, (res: any) => {
                if (Array.isArray(res[entity]) && res[entity].length > 0 && Array.isArray(data[entity])) {
                    // Sind Datensätze am Server entfernt, entfernen wir die lokalen auch.
                    data[entity].forEach((r: any, idx: number) => {
                        if (r.parent_tid === tid) {
                            const fnd = res[entity].find((d: any) => d.tid === r.tid);
                            if (!fnd) {
                                data[entity].splice(idx, 1);
                            }
                        }
                    });
                    // Aktualisieren die lokalen Datensätze
                    res[entity].forEach((row: any) => {
                        const idx = data[entity].findIndex((r: any) => r.tid === row.tid);
                        if (idx >= 0) {
                            data[entity][idx] = row;
                        } else {
                            data[entity].push(row);
                        }
                    });
                }
            }, IDs.MOD_ETOOL);
        }
    }

    updateArchiv(rowOld: any, rowNew: any) {
        const { formConig } = this.state;
        // console.log(formConig, rowOld, rowNew);
        if (Array.isArray(formConig.items)) {
            const doUpdate = formConig.items.filter((i: any) => i.typ === 'archiv')
                .some((i: any) => rowOld.hasOwnProperty(i.key) && rowNew.hasOwnProperty(i.key) &&
                    (rowOld[i.key] < rowNew[i.key] /* ersetzt */ || (rowOld[i.key] > 0 && !rowNew[i.key]) /* gelöscht */));
            if (doUpdate) {
                const keyAddOn = this.state.keyAddOn + 1;
                this.setState({ keyAddOn });
            }
        }
    }

    renderButtonAdd(simple = false) {
        return (
            <WActionButton
                label={'Zusätzlichen Datensatz erfassen'}
                insideText={!simple ? 'Zusätzlichen Datensatz erfassen' : undefined}
                key='add'
                action='theme_add'
                style='theme'
                styleProps={{ margin: 0, }}
                onAction={() => this.setState({ selectedDatensatz: 0 }, () => {
                    this.checkAllowContinue({});
                    this.props.scrollTop();
                })}
            />
        );
    }

    renderButtonDel(simple = false) {
        return (
            <WActionButton
                label='Datensatz Löschen'
                insideText={!simple ? 'Datensatz löschen' : undefined}
                key='delete'
                action='theme_delete'
                style='theme'
                styleProps={{ margin: 0 }}
                onAction={() => {
                    const row = this.state.selectedDatensatz;
                    const doDelete = () => {
                        if (!window.confirm('Datensatz wirklich löschen?')) {
                            return;
                        }
                        const { data } = this.props;
                        const entName = this.props.item.entity;
                        const fndRows = data[entName].filter((r: any) => r.tid === row.tid || (r.parent_tid > 0 && r.parent_tid === row.tid));
                        let cnt = fndRows.length;
                        if (cnt > 0) {
                            fndRows.forEach((f: any) => {
                                this.dataService.delData(entName, IDs.MOD_ETOOL, { tid: f.tid }, {}, () => {
                                    const idx = data[entName].findIndex((r: any) => r.tid === f.tid);
                                    if (idx >= 0) {
                                        data[entName].splice(idx, 1);
                                        this.props.onPruefItemChange({ tid: f.tid }, 'deleted');
                                    }
                                    cnt--;
                                    if (cnt === 0) {
                                        // console.log(data[entName]);
                                        this.setState({ selectedDatensatz: 0 }, () => this.checkAllowContinue({}));
                                        this.triggerService.fire('reload', this.props.item.entity);
                                    }
                                });
                            });
                        }
                    };
                    if (this.props.callBeforeDelete) {
                        this.props.callBeforeDelete(row, doDelete);
                    } else {
                        doDelete();
                    }
                }}
            />
        );
    }

    renderDatensatzSelect(list: Array<any>, showItem: any) {
        if (!list) {
            return <select disabled={true}><option>Nicht verfügbar</option></select>;
        }
        if (list.length === 0) {
            return <div
                style={{ height: 0 }}
            />;
        }
        list = list.filter((item: any) => !item.monat
            && ((this.parentEntities || []).indexOf(this.props.item.entity) === -1 || (+item.parent_tid || 0) === 0));
        const val = this.state.selectedDatensatz ? this.state.selectedDatensatz.tid : 0;
        const styleSelect: React.CSSProperties = val ? { maxWidth: 465, minWidth: 465 } : { maxWidth: 505, minWidth: 505 };
        return (
            <div
                className={styleWForm.flowV2}
                style={{ padding: '0 32px 0 22px' }}
            >
                {list && list.length > 0 &&
                    <div style={{ display: 'flex', flexDirection: 'row', paddingBottom: 5 }}>
                        <b>{list.length}</b>&nbsp;vorhandene Datensätze
                        <WHelpIcon
                            data={this.props.data}
                            styleDivProps={{ marginTop: 6, marginLeft: 10, marginRight: 0 }}
                            styleProps={{ width: 16, height: 14, borderRadius: 10, backgroundColor: 'transparent', margin: 0 }}
                            label={'Info "Vorhandene Datensätze"'}
                            helpKey={'vorhandene_datensaetze'}
                            style={'theme_small'}
                            type={'theme_info'}
                            editBar={true}
                            customElement={'Info'}
                            useTheme={true}
                        />
                    </div>
                }
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <select
                        className={style.ds_select}
                        style={styleSelect}
                        value={val}
                        onChange={(evt: any) => {
                            const selectedDatensatz = list.find((s: any) => s.tid + '' === evt.target.value + '');
                            // console.log('CHANGE', selectedDatensatz);
                            this.setState({ selectedDatensatz, tidAnnounced: undefined });
                            const contextKey = AssistentEntityForm.getContextKey(this.props.item, this.props.jahr, (this.props.standort || {}).tid);
                            this.contextService.set(contextKey, evt.target.value);
                            this.checkAllowContinue(selectedDatensatz || {});
                        }}
                    >
                        <option
                            value={0}
                            style={{ color: '#aaa' }}
                        >
                            Neuer Datensatz
                        </option>
                        {list.map((ds: any, idx: number) => {
                            let bgCol = '#fff';
                            if (this.props.pruefItem) {
                                this.props.pruefItem.pruefTids.forEach((tid: number, idxPrf: number) => {
                                    if (tid === ds.tid) {
                                        const result: any = this.props.pruefItem.pruefResult[idxPrf] || {};
                                        const errors = Object.keys(result).length;
                                        const isValid: boolean = !Object.values(result)
                                            .some((value: string) => getErrorLevelKey(value) !== 'warning');
                                        if (errors === 0 || isValid) {
                                            bgCol = '#dfd';
                                        } else {
                                            bgCol = '#fdd';
                                        }
                                    }
                                });
                            }
                            return <option
                                key={`ds_${idx}`}
                                value={ds.tid}
                                style={{ backgroundColor: bgCol }}
                            >
                                {renderDatensatzForSelect(ds, this.state.bundle, this.state.formConig, this.props.item.entity, list)}
                            </option>;
                        })}
                    </select>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        {!this.props.dataItem ?
                            <div style={{ marginLeft: 5 }}>{this.renderButtonAdd(true)}</div> : null}
                        {this.state.selectedDatensatz && !this.props.dataItem ?
                            <div style={{ marginLeft: 5 }}>{this.renderButtonDel(true)}</div> : null}
                    </div>
                </div>
            </div>
        );
    }

    renderCutomTopElement(showItem: any) {
        return <div style={{ marginLeft: 0, marginBottom: 10 }}>
            {this.props.item.customTopElement(this.props.item.entity, showItem, (data: any) => {
                if (this.props.item.entity === IDs.ENT_STANDORT) {
                    const ds = this.state.selectedDatensatz;
                    const dsNew = data && Array.isArray(data[IDs.ENT_STANDORT]) &&
                        data[IDs.ENT_STANDORT].find((d: any) => d.tid === ds.tid);
                    if (dsNew) {
                        // Nach der Übernahme muss ein Update für Formdaten
                        this.setState({ selectedDatensatz: undefined },
                            () => this.setState({ selectedDatensatz: dsNew }));
                    }
                } else if (
                    [IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE, IDs.ENT_ENERGIEDATEN_STROM, IDs.ENT_ENERGIEDATEN_WAERME]
                        .indexOf(this.props.item.entity) !== -1
                ) {
                    this.setState({ selectedDatensatz: undefined },
                        () => {
                            this.setState({ selectedDatensatz: data });
                            // console.log('SETTING ', data);
                        }
                    );
                }
            })}
        </div>;
    }

    setFocusOnInput() {
        // Den Eingabefeld wieder fokussieren.
        if (this.currentFormTarget) {
            const tag = this.currentFormTarget.tagName;
            const id = this.currentFormTarget.id;
            let ele;
            if (tag === 'INPUT') {
                ele = document.getElementById(id) as HTMLInputElement;
            } else if (tag === 'TEXTAREA') {
                ele = document.getElementById(id) as HTMLTextAreaElement;
            }
            // console.log(id, ele);
            if (ele) {
                ele.focus();
                const val = ele.value;
                ele.value = '';
                ele.value = val;
            }
        }
    }

    getFormKey(item: any, data: any, formConfig: any) {
        const teilstreckenEntities: any = [
            IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT, // 4
            IDs.ENT_CO2_SCOPE3_REISEN, // 6
            IDs.ENT_CO2_SCOPE3_PENDELN, // 7
            IDs.ENT_CO2_SCOPE3_TRANSPORT_NACHGELAGERT // 9
        ];
        const teilstreckenVals = (teilstreckenEntities.indexOf(item.entity) !== -1 && data) ? `${data.teilstrecken_orig || 0}_${data.hin_rueck_orig || 0}` : 0;
        const formKey = [
            'assistent_form',
            item.name,
            item.entity,
            data && data.tid ? data.tid : 0,
            data && data.energietraeger_tid_orig ? data.energietraeger_tid_orig : 0,
            teilstreckenVals,
            item.entity === IDs.ENT_UNTERNEHMENSDATEN && data ?
                `${data.plz || 0}_${data.gewerk_tid || 0}` : 0,
            this.state.keyAddOn,
            JSON.stringify(formConfig)
        ].join('_');
        // console.log(formKey);
        return formKey;
    }

    static getContextKey(item: any, jahr: number, standortTtid: any) {
        const contextKey = [
            'assistent_context',
            item.name,
            item.entity,
            jahr || 0,
            standortTtid || 0
        ].join('_');
        // console.log(contextKey);
        return contextKey;
    }
}
